import React from "react";
import PropTypes, { node } from "prop-types";
import { connect } from "react-redux";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  trackPageInteraction,
  getGender,
  ANALYTICS_INTERACTION_CLICK,
  ANALYTICS_POSITION_HEADER,
  ANALYTICS_CONTEXT
} from "@src/helpers/events";
import { addAnalyticsDataToLink } from "@template/helpers/addAnalyticsDataToLink";
import { getFeature } from "@template/state/modules/features";

const NavAnchor = props => {
  const {
    item,
    children,
    marketplaceVintageLinkMobile,
    marketplaceVintageLinkDesktop,
    // eslint-disable-next-line no-unused-vars
    dispatch,
    ...restOfProps
  } = props;
  const { gender, label } = item;

  const handleClick = () => {
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: getGender(gender)
      }
    });
  };

  const target = item.linkType === "external" ? "_blank" : null;

  return (
    <a
      {...restOfProps}
      onClick={handleClick}
      href={addAnalyticsDataToLink({
        ...item,
        marketplaceVintageLinkMobile,
        marketplaceVintageLinkDesktop
      })}
      target={target}
    >
      {children}
    </a>
  );
};

NavAnchor.propTypes = {
  item: navigationPropType.isRequired,
  children: node.isRequired,
  marketplaceVintageLinkDesktop: PropTypes.oneOfType([
    PropTypes.shape({
      enabled: PropTypes.bool
    }),
    PropTypes.bool
  ]),
  marketplaceVintageLinkMobile: PropTypes.oneOfType([
    PropTypes.shape({
      enabled: PropTypes.bool
    }),
    PropTypes.bool
  ]),
  dispatch: PropTypes.func
};

const mapStateToProps = state => {
  const marketplaceVintageLinkMobile = getFeature(
    state,
    "emf-137-mweb-marketplace-clothing-nav-edit"
  );
  const marketplaceVintageLinkDesktop = getFeature(
    state,
    "emf-95-desktop-marketplace-clothing-nav-edit"
  );

  return {
    marketplaceVintageLinkMobile: marketplaceVintageLinkMobile,
    marketplaceVintageLinkDesktop: marketplaceVintageLinkDesktop
  };
};

export default connect(mapStateToProps)(NavAnchor);
